import { Drawer, Dropdown, Menu } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useDeviceWidth from "../../device-width/UseDeviceWidth";
import classes from "./Navbar.module.css";
import NavbarDropdown from "./dropdown/NavbarDropdown";
import Services from "./dropdown/Services";
import Hospitals from "./dropdown/Hospitals";
import { useLabReport } from "../../../components/layout/Layout";
import pagesService from "../../../services/pages";
import informationPolicyService from "../../../services/informationPolicy";
import { useSelector } from "react-redux";

const Navbar = ({
  settings,
  branches,
  branchesLoading,
  services,
  servicesLoading,
}) => {
  const navigate = useNavigate();
  const servicesButtonRef = useRef(null);
  const hospitalsButtonRef = useRef(null);
  const width = useDeviceWidth();
  const [sideMenuVisible, setSideMenuVisible] = useState(false);

  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showHospitalsDropdown, setShowHospitalsDropdown] = useState(false);
  const { showLabReportModal, setShowLabReportModal } = useLabReport();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const { homeApis } = useSelector((state) => state.widget); // Access widget data

  const openDrawer = () => {
    setSideMenuVisible(true);
  };

  const onClose = () => {
    setSideMenuVisible(false);
  };

  function isSameURL(givenURL) {
    const currentURL = window.location.pathname; // Get the current URL of the page
    return givenURL === currentURL; // Compare the given URL with the current URL
  }

  const menuItems = [
    {
      key: "our-hospitals",
      label: "Our Hospitals",
      children: branches?.map((branch) => {
        return {
          key: branch._id,
          label: (
            <Link
              to={`/branch/${branch.slug}`}
              onClick={() => setSideMenuVisible(false)}
            >
              {branch.name}
            </Link>
          ),
        };
      }),
      // children: [
      //   {
      //     key: "our-hospitals-1",
      //     label: "Muvattupuzha",
      //   },
      //   {
      //     key: "our-hospitals-2",
      //     label: "Trivandrum",
      //   },
      // ],
    },
    {
      key: "services",
      label: "Services",
      children: services?.map((service) => {
        return {
          key: service._id,
          label: (
            <Link
              to={`/services/${service.slug}`}
              onClick={() => setSideMenuVisible(false)}
            >
              {service.title}
            </Link>
          ),
        };
      }),
    },
  ];

  const closeServiceDropdown = (event) => {
    // Prevent closing when clicking the button
    if (
      servicesButtonRef.current &&
      servicesButtonRef.current.contains(event.target)
    ) {
      return;
    }
    setShowServicesDropdown(false);
  };

  const closeHospitalsDropdown = (event) => {
    // Prevent closing when clicking the button
    if (
      hospitalsButtonRef.current &&
      hospitalsButtonRef.current.contains(event.target)
    ) {
      return;
    }
    setShowHospitalsDropdown(false);
  };

  // const fetchInfertility = async () => {
  //   try {
  //     const data = await pagesService.getAll(
  //       `?categorySlug=infertility-treatment&sortByPriority=true`
  //     );
  //     console.log("fetched infertility", data);
  //     if (data?.data?.length > 0) {
  //       setBlogs(data?.data);
  //     } else {
  //       setBlogs([]);
  //     }
  //     setLoading(false);
  //   } catch (err) {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchInfertility();
  // }, []);

  const handleVisibleChange = (flag) => {
    setDropdownVisible(flag);
  };

  const menu = (
    <div className={classes.infertilityOuter}>
      {homeApis?.pages?.map((item) => (
        <li
          className="primaryHover"
          onClick={() => {
            setDropdownVisible(false); // CLOSE DROPDOWN
            navigate(`/infertility-treatment/${item?.slug}`);
          }}
        >
          {item?.title}
        </li>
      ))}
    </div>
  );


  return (
    <>
      <div className={`${classes.miniNavbar} bg-primary-500`}>
        <div className={classes.miniItems}>
          <p onClick={() => navigate("/careers")}>Careers</p>
          <p onClick={() => navigate("/contact-us")}>Contact us</p>
          {/* {width >= 768 && ( */}
          <a
            href={`https://wa.me/${settings?.[0]?.whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <img
              className={classes.whatsAppIcon}
              src="/img/icons/nav-whatsapp.svg"
              alt="logo"
            />
          </a>
          {/* )} */}
        </div>
      </div>
      <header className={`${classes.navbarDiv}`}>
        <div className={`${classes.container}`}>
          {/* Logo section */}
          <Link to="/">
            <img src="/img/logo.svg" alt="logo" className={classes.logo} />
          </Link>

          {/* Navbar links and menu */}
          {width >= 1230 && (
            <nav>
              <ul className={classes.linksDiv}>
                {/* <Link to="/">
                  <li className={classes.link}>
                    <div>Home</div>
                  </li>
                </Link> */}
                {/* <Link to="/ivf">
                  <li className={classes.link}>
                    <div>IVF</div>
                  </li>
                </Link> */}
                {/* <Link> */}
                <li className={`${classes.link} ${classes.hospitalLink}`}>
                  <div
                    className={classes.transparentDiv}
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowHospitalsDropdown(true)}
                    onMouseEnter={() => {
                      setShowHospitalsDropdown((prev) => !prev);
                    }}
                    onMouseLeave={() => {
                      setShowHospitalsDropdown((prev) => !prev);
                    }}
                  ></div>
                  {/* <Dropdown
                      menu={{
                        items: branches?.map((branch) => {
                          return {
                            key: branch._id,
                            label: (
                              <Link to={`/branch/${branch.slug}`}>
                                {branch.name}
                              </Link>
                            ),
                          };
                        }),
                      }}
                      // menu={menu}
                      placement="bottom"
                      trigger={["hover"]}
                      overlayClassName="navbar-menu"
                      dropdownRender={(menu) => <div className="">{menu}</div>}
                    > */}
                  <div
                    className={`${classes.dropLink}`}
                    // className="tw-text-primary-500 tw-font-primary tw-text-[16px] tw-font-semibold tw-leading-normal tw-not-italic tw-flex tw-flex-row tw-items-center tw-gap-[10px]"
                    ref={hospitalsButtonRef}
                    onClick={(e) => {
                      e.preventDefault();
                      //setShowHospitalsDropdown((prev) => !prev);
                    }}
                    // onMouseEnter={() => {
                    //   setShowHospitalsDropdown((prev) => !prev);
                    // }}
                    // onMouseLeave={() => {
                    //   setShowHospitalsDropdown((prev) => !prev);
                    // }}
                  >
                    Our Hospitals
                    <img
                      src="/img/icons/dropdown-arrow.svg"
                      alt="arrow"
                      // className="tw-max-w-[124px] md:tw-max-w-[212px] lg:tw-max-w-[290px]"
                    />
                  </div>
                  {/* </Dropdown> */}
                </li>
                {/* </Link> */}
                {/* <Link > */}
                <li className={`${classes.link} ${classes.hospitalLink}`}>
                  <div
                    className={classes.transparentDiv}
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowServicesDropdown(true)}
                    onMouseEnter={() => {
                      setShowServicesDropdown((prev) => !prev);
                    }}
                    onMouseLeave={() => {
                      setShowServicesDropdown((prev) => !prev);
                    }}
                  ></div>
                  {/* <Dropdown
                      menu={{
                        items: services?.map((service) => {
                          return {
                            key: service._id,
                            label: (
                              <Link to={`/services/${service.slug}`}>
                                {service.title}
                              </Link>
                            ),
                          };
                        }),
                      }}
                      // menu={menu}
                      placement="bottom"
                      trigger={["hover"]}
                      overlayClassName="navbar-menu"
                      dropdownRender={(menu) => <div className="">{menu}</div>}
                    > */}
                  <div
                    className={`${classes.dropLink}`}
                    ref={servicesButtonRef}
                    onClick={(e) => {
                      e.preventDefault();
                      //setShowServicesDropdown((prev) => !prev);
                    }}
                  >
                    Services
                    <img
                      src="/img/icons/dropdown-arrow.svg"
                      alt="arrow"
                      // className="tw-max-w-[124px] md:tw-max-w-[212px] lg:tw-max-w-[290px]"
                    />
                  </div>
                  {/* </Dropdown> */}
                </li>
                <div>
                  <Dropdown
                    onVisibleChange={handleVisibleChange}
                    dropdownClassName="infertility-dropdown"
                    overlay={menu}
                    visible={dropdownVisible}
                    trigger={["hover"]}
                  >
                    <li className={classes.link}>
                      {/* <Link to="/doctors?page=1&limit=14"> */}
                      <div
                        className={classes.infertDiv}
                        style={{ cursor: "pointer" }}
                      >
                        Infertility Treatment
                        <img
                          src="/img/icons/dropdown-arrow.svg"
                          alt="arrow"
                          // className="tw-max-w-[124px] md:tw-max-w-[212px] lg:tw-max-w-[290px]"
                        />
                      </div>
                      {/* </Link> */}
                    </li>
                  </Dropdown>
                </div>
                {/* </Link> */}
                <Link to="/doctors">
                  <li className={classes.link}>
                    <div>Doctors</div>
                  </li>
                </Link>
                <Link to="/gallery">
                  <li className={classes.link}>
                    <div>Gallery</div>
                  </li>
                </Link>
                {/* <Link to="/contact-us">
                  <li className={classes.link}>
                    <div>Contact</div>
                  </li>
                </Link> */}
              </ul>
            </nav>
          )}

          {/* Buttons section */}
          <div className={classes.rightSection}>
            {width >= 768 && (
              <div className={classes.phoneDiv}>
                <img src="/img/icons/call-icon.svg" alt="logo" />
                <a
                  href={`tel:${homeApis?.adminSettings?.[0]?.contactNumber}`}
                  style={{ textDecoration: "none" }}
                >
                  <h4>{homeApis?.adminSettings?.[0]?.contactNumber}</h4>
                </a>
              </div>
            )}
            {/* {width >= 768 && (
              <a
                href={`https://wa.me/${settings?.whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <img src="/img/icons/nav-whatsapp.svg" alt="logo" />
              </a>
            )} */}
            {width >= 768 && (
              <button
                onClick={() => navigate(`/consultation`)}
                className={`${classes.bookOnline} bg-primary-500`}
              >
                Book Appointment
              </button>
            )}
            <img
              src="/img/icons/humburger.svg"
              alt="menu"
              className={classes.humburger}
              onClick={() => openDrawer()}
            />
          </div>
        </div>
        {showServicesDropdown && (
          <NavbarDropdown
            showDropdown={showServicesDropdown}
            closeDropdown={closeServiceDropdown}
            setDropdown={setShowServicesDropdown}
          >
            <Services
              services={services}
              servicesLoading={servicesLoading}
              setShowServicesDropdown={setShowServicesDropdown}
            />
          </NavbarDropdown>
        )}
        {showHospitalsDropdown && (
          <NavbarDropdown
            showDropdown={showHospitalsDropdown}
            closeDropdown={closeHospitalsDropdown}
            setDropdown={setShowHospitalsDropdown}
          >
            <Hospitals
              branches={branches}
              branchesLoading={branchesLoading}
              setShowHospitalsDropdown={setShowHospitalsDropdown}
              settings={settings}
            />
          </NavbarDropdown>
        )}
      </header>
      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={onClose}
        open={sideMenuVisible}
        key="right"
        width={width <= 768 ? 250 : width <= 1200 ? 400 : 434}
        className={`nav-menu ${classes.drawer}`}
        styles={{ header: { display: "none" } }}
      >
        <div className={`${classes.closeIconDiv}`} onClick={() => onClose()}>
          <img
            src="/img/icons/nav-close.svg"
            alt="close"
            className={classes.closeIcon}
          />
        </div>
        <div className={classes.menuListDiv}>
          <Link to="/">
            <img
              src="/img/logo.svg"
              alt="logo"
              className={classes.menuLogo}
              onClick={() => onClose()}
            />
          </Link>

          <div className={classes.burgerButtons}>
            <button
              onClick={() => {
                setSideMenuVisible(false);
                navigate(`/consultation`);
              }}
              className={`${classes.bookOnline} bg-primary-500`}
            >
              Book Appointment
            </button>
            <button
              onClick={() => setShowLabReportModal(true)}
              className={`${classes.labReport} primary-500 primaryHover`}
            >
              Lab Report
            </button>
          </div>

          <div className={classes.quickContact}>
            <p className={classes.quickContactHead}> Quick Contact</p>
            <div className={classes.quickContactItemDiv}>
              <img
                src="/img/icons/side-phone.svg"
                alt="contact"
                className={classes.phoneIcon}
              />
              <a
                href={`tel:${homeApis?.adminSettings?.[0]?.contactNumber}`}
                className={classes.quickContactItem}
              >
                {homeApis?.adminSettings?.[0]?.contactNumber}
              </a>
            </div>
            <div className={classes.quickContactItemDiv}>
              <img
                src="/img/icons/nav-whatsapp.svg"
                alt="whatsapp"
                className={classes.whatsappIcon}
              />
              <a
                href={`https://wa.me/${homeApis?.adminSettings?.[0]?.whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.quickContactItem}
              >
                {homeApis?.adminSettings?.[0]?.whatsappNumber}
              </a>
            </div>
          </div>

          <div className={classes.menuItems}>
            <Link to="/">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/") ? classes.bgPrimary : classes.bgWhite
                }`}
                onClick={() => onClose()}
              >
                <div
                  className={`${
                    isSameURL("/") ? classes.textWhite : classes.textPrimary
                  }  ${classes.menuText}`}
                >
                  Home
                </div>
              </li>
            </Link>

            <Menu mode="inline" items={menuItems} className="filter-menu" />

            <Link to="/doctors">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/doctors") ? classes.bgPrimary : classes.bgWhite
                }`}
                onClick={() => setSideMenuVisible(false)}
              >
                <div
                  className={`${
                    isSameURL("/doctors")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                >
                  Doctors
                </div>
              </li>
            </Link>
            <Link to="/contact-us">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/contact-us") ? classes.bgPrimary : classes.bgWhite
                }`}
                onClick={() => setSideMenuVisible(false)}
              >
                <div
                  className={`${
                    isSameURL("/contact-us")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  // onClick={() => setSideMenuVisible(false)}
                >
                  Contact
                </div>
              </li>
            </Link>
            {/* <Link to="/medical-tourism">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/medical-tourism")
                    ? classes.bgPrimary
                    : classes.bgWhite
                }`}
              >
                <div
                  className={`${
                    isSameURL("/medical-tourism")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  onClick={() => onClose()}
                >
                  Medical Tourism
                </div>
              </li>
            </Link> */}
            <Link to="/testimonials">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/testimonials")
                    ? classes.bgPrimary
                    : classes.bgWhite
                }`}
                onClick={() => setSideMenuVisible(false)}
              >
                <div
                  className={`${
                    isSameURL("/testimonials")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  // onClick={() => setSideMenuVisible(false)}
                >
                  Testimonials
                </div>
              </li>
            </Link>
            <Link to="/investor-and-relations">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/investor-and-relations")
                    ? classes.bgPrimary
                    : classes.bgWhite
                }`}
                onClick={() => setSideMenuVisible(false)}
              >
                <div
                  className={`${
                    isSameURL("/investor-and-relations")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  // onClick={() => setSideMenuVisible(false)}
                >
                  Investors & Relations
                </div>
              </li>
            </Link>
            {/* <Link to="/about-us">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/about-us") ? classes.bgPrimary : classes.bgWhite
                }`}
              >
                <div
                  className={`${
                    isSameURL("/about-us")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  onClick={() => onClose()}
                >
                  About Us
                </div>
              </li>
            </Link>
            <Link to="/our-story">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/our-story") ? classes.bgPrimary : classes.bgWhite
                }`}
              >
                <div
                  className={`${
                    isSameURL("/our-story")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  onClick={() => onClose()}
                >
                  Our Story
                </div>
              </li>
            </Link> */}
            {/* <Link to="/management-team">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/management-team")
                    ? classes.bgPrimary
                    : classes.bgWhite
                }`}
              >
                <div
                  className={`${
                    isSameURL("/management-team")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  onClick={() => onClose()}
                >
                  Management Team
                </div>
              </li>
            </Link> */}
            <Link to="/gallery">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/gallery") ? classes.bgPrimary : classes.bgWhite
                }`}
                onClick={() => setSideMenuVisible(false)}
              >
                <div
                  className={`${
                    isSameURL("/gallery")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  // onClick={() => setSideMenuVisible(false)}
                >
                  Gallery
                </div>
              </li>
            </Link>
            <Link to="/blogs">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/blogs") ? classes.bgPrimary : classes.bgWhite
                }`}
                onClick={() => setSideMenuVisible(false)}
              >
                <div
                  className={`${
                    isSameURL("/blogs")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  // onClick={() => setSideMenuVisible(false)}
                >
                  News & Events
                </div>
              </li>
            </Link>
            <Link to="/careers">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/careers") ? classes.bgPrimary : classes.bgWhite
                }`}
                onClick={() => setSideMenuVisible(false)}
              >
                <div
                  className={`${
                    isSameURL("/careers")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  // onClick={() => setSideMenuVisible(false)}
                >
                  Careers
                </div>
              </li>
            </Link>
            {/*
            <Link to="/csr-policy">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/csr-policy") ? classes.bgPrimary : classes.bgWhite
                }`}
              >
                <div
                  className={`${
                    isSameURL("/csr-policy")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  onClick={() => onClose()}
                >
                  CSR Policy
                </div>
              </li>
            </Link>
            <Link to="/refund-policy">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/refund-policy")
                    ? classes.bgPrimary
                    : classes.bgWhite
                }`}
              >
                <div
                  className={`${
                    isSameURL("/refund-policy")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  onClick={() => onClose()}
                >
                  Refund and Return Policy
                </div>
              </li>
            </Link>
            <Link to="/terms-of-use">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/terms-of-use")
                    ? classes.bgPrimary
                    : classes.bgWhite
                }`}
              >
                <div
                  className={`${
                    isSameURL("/terms-of-use")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  onClick={() => onClose()}
                >
                  Terms of use
                </div>
              </li>
            </Link>
            <Link to="/privacy-policy">
              <li
                className={`${classes.menuItem} ${
                  isSameURL("/privacy-policy")
                    ? classes.bgPrimary
                    : classes.bgWhite
                }`}
              >
                <div
                  className={`${
                    isSameURL("/privacy-policy")
                      ? classes.textWhite
                      : classes.textPrimary
                  }  ${classes.menuText}`}
                  onClick={() => onClose()}
                >
                  Privacy Policy
                </div>
              </li>
            </Link> */}
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default Navbar;
